module.exports = __webpack_public_path__ + "img/Vector.b9a7777e.svg";